<template>
  <div class="estimate">
    <button class="btn btn-success mb-2" @click.prevent="print">PDFで保存</button>
    <div class="created-at">
      <dl>
        <dt>発行日:</dt>
        <dd>{{ new Date() | moment('YYYY年MM月DD日') }}</dd>
      </dl>
    </div>
    <div class="eligible-invoice-issuer">
      <dl>
        <dt>登録番号:</dt>
        <dd>T7010901027836</dd>
      </dl>
    </div>

    <h2>見積書</h2>

    <div class="header clearfix">
      <div class="left-box">
        <template v-if="order.group_name">
          <div class="group-name">{{order.group_name}}</div>

          <div class="customer-name">
            <dl>
              <dt>ご担当者名：</dt>
              <dd>{{order.customer_name}} 様</dd>
            </dl>
          </div>
        </template>
        <template v-else>
          <div class="group-name">{{order.customer_name}} 様</div>
        </template>

        <div class="delivery-on">
          <dl>
            <dt>配達日：</dt>
            <dd v-if="order.order_type === 'catering'">
              {{order.catering_on | moment("YYYY年MM月DD日")}}
            </dd>
            <dd v-else-if="order.order_type === 'delivery'">
              {{order.delivery_on | moment("YYYY年MM月DD日")}}
            </dd>
          </dl>
        </div>

        <div class="delivery-place">
          <dl>
            <dt>配達場所：</dt>
            <dd>{{order.prefecture}} {{order.city}} {{order.address}} {{order.building_name}}</dd>
          </dl>
        </div>

        <div class="price">
          <div>下記の通りお見積り申し上げます。</div>
          <div class="left">お見積り金額</div>
          <div class="right">
            {{calculationResult.total_price | currency}}
            <span>(税込)</span>
          </div>
        </div>
      </div><!-- /.left-box -->

      <div class="right-box">
        <img src="../../images/logo.png" class="mb-3">
        <div class="shop-tel">
          <dl>
            <dt>電話</dt>
            <dd>050-5434-9753</dd>
          </dl>
        </div>
        <div class="shop-address">
          <dl>
            <dt>住所</dt>
            <dd>
              〒154-0003
              <br>
              東京都世田谷区野沢2-14-1 雨宮ビル1階
            </dd>
          </dl>
        </div>
        <div class="shop-email">
          <dl>
            <dt>Email</dt>
            <dd>info@catering-season.com</dd>
          </dl>
        </div>
      </div><!-- /.right-box -->
    </div><!-- /.clearfix -->

    <table class="price-table">
      <tbody><tr class="plan-tbl__row">
        <th>項目</th>
        <th>単価</th>
        <th>数量</th>
        <th>単位</th>
        <th>金額</th>
      </tr>

      <tr class="heading">
        <td colspan="5">お料理</td>
      </tr>
      <tr class="plan-row">
        <td class="name">({{orderTypeJa[order.order_type]}}/{{mealTypeJa[order.meal_type]}}) {{order.plan_name}}</td>
        <td class="unit-price">{{order.plan_price | currency({symbol: ''})}}</td>
        <td class="quantity">{{order.quantity}}</td>
        <td class="unit-name">人</td>
        <td class="price">{{order.quantity * order.plan_price | currency}}</td>
      </tr>

      <!-- ドリンクセット -->
      <template v-if="order.drink_sets.length > 0">
        <tr class="heading">
          <td colspan="5">ドリンクセット</td>
        </tr>
        <tr class="drink-set-row" v-for="drink_set in order.drink_sets">
          <td class="name">{{drink_set.name}}</td>
          <td class="unit-price">{{drink_set.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink_set.quantity}}</td>
          <td class="unit-name">セット</td>
          <td class="price">{{drink_set.quantity * drink_set.price | currency}}</td>
        </tr>
      </template>

      <!-- ドリンク(単品) -->
      <template v-if="singleDrinks.length > 0">
        <tr class="heading">
          <td colspan="5">ドリンク(単品)</td>
        </tr>
        <tr class="drink-row" v-for="drink in singleDrinks">
          <td class="name">{{drink.name}}</td>
          <td class="unit-price">{{drink.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink.quantity}}</td>
          <td class="unit-name">{{drink.unit_name}}</td>
          <td class="price">{{drink.quantity * drink.price | currency}}</td>
        </tr>
      </template>

      <!-- 備品 -->
      <template v-if="equipments.length > 0">
        <tr class="heading">
          <td colspan="5">備品</td>
        </tr>
        <tr class="equipment-row" v-for="equipment in equipments">
          <td class="name">{{equipment.name}}</td>
          <td class="unit-price">{{equipment.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{equipment.quantity}}</td>
          <td class="unit-name">{{equipment.unit_name}}</td>
          <td class="price">{{equipment.quantity * equipment.price | currency}}</td>
        </tr>
      </template>

      <!-- ドリンクプラン -->
      <template v-if="calculationResult.drink_plans.length > 0">
        <tr class="heading">
          <td colspan="5">ドリンクプラン</td>
        </tr>
        <tr class="drink-plan-row" v-for="drink_plan in calculationResult.drink_plans">
          <td class="name">{{drink_plan.name}}</td>
          <td class="unit-price">{{drink_plan.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{drink_plan.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{drink_plan.quantity * drink_plan.price | currency}}</td>
        </tr>
      </template>

      <!-- 追加料理 -->
      <template v-if="calculationResult.dishes.length > 0">
        <tr class="heading">
          <td colspan="5">追加料理</td>
        </tr>
        <tr class="dish-row" v-for="dish in calculationResult.dishes">
          <td class="name">{{dish.name}}</td>
          <td class="unit-price">{{dish.price | currency({symbol: ''})}}</td>
          <td class="quantity">{{dish.quantity}}</td>
          <td class="unit-name">{{dish.unit_name}}</td>
          <td class="price">{{dish.quantity * dish.price | currency}}</td>
        </tr>
      </template>

      <!-- オプション -->
      <template v-if="order.use_tablecloth || order.use_exothermic_agent || order.use_plate">
        <tr class="heading">
          <td colspan="5">オプション</td>
        </tr>

        <tr class="plate-row" v-if="order.use_plate">
          <td class="name">取皿セット</td>
          <td class="unit-price">{{calculationResult.plate.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.plate.quantity}}</td>
          <td class="unit-name">枚</td>
          <td class="price">{{calculationResult.plate.price | currency}}</td>
        </tr>

        <tr class="exothermic-row" v-if="order.use_exothermic_agent">
          <td class="name">発熱剤</td>
          <td class="unit-price">{{calculationResult.exothermic_agent.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.exothermic_agent.quantity}}</td>
          <td class="unit-name">個</td>
          <td class="price">{{calculationResult.exothermic_agent.price | currency}}</td>
        </tr>

        <tr class="tablecloth-row" v-if="order.use_tablecloth">
          <td class="name">テーブルクロス</td>
          <td class="unit-price">{{calculationResult.tablecloth.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.tablecloth.quantity}}</td>
          <td class="unit-name">式</td>
          <td class="price">{{calculationResult.tablecloth.price | currency}}</td>
        </tr>
      </template>

      <template v-if="order.order_type === 'catering'">
        <tr class="heading">
          <td colspan="5">その他</td>
        </tr>
        <tr class="worker-row">
          <td class="name">
            スタッフ派遣料<br>
            <span v-if="calculationResult.drink_plans.length > 0">(バーテンダー料金)</span>
            <span v-else>(設置・撤収料金)</span>
          </td>
          <td class="unit-price">{{calculationResult.worker.unit_price | currency({symbol: ''})}}</td>
          <td class="quantity">{{calculationResult.worker.quantity}}</td>
          <td class="unit-name">人</td>
          <td class="price">{{calculationResult.worker.price | currency}}</td>
        </tr>
      </template>

      <tr class="deliver-price">
        <td rowspan="4"></td>
        <td colspan="3">
          <span v-if="order.city">{{order.prefecture}}{{order.city}}への送料</span>
          <span v-else>送料(配達先住所が入力されていません)</span>
        </td>
        <td>{{calculationResult.delivery_price | currency}}</td>
      </tr>

      <tr class="sub-total">
        <td colspan="3">小計金額</td>
        <td>{{calculationResult.normal_tax_rate.sub_total + calculationResult.reduced_tax_rate.sub_total | currency}}</td>
      </tr>

      <tr class="tax">
        <td colspan="3">消費税</td>
        <td>{{calculationResult.normal_tax_rate.tax + calculationResult.reduced_tax_rate.tax | currency}}</td>
      </tr>

      <tr class="total-price">
        <td colspan="3">合計金額</td>
        <td>{{calculationResult.total_price | currency}}</td>
      </tr>
      </tbody>
    </table>

    <div class="tab-table clearfix mb-2">
      <table class="tax-table float-right">
        <tr class="reduced-tax-rate" v-if="order.order_type === 'delivery'">
          <td>8%対象</td>
          <td>{{calculationResult.reduced_tax_rate.sub_total | currency }}</td>
          <td>消費税</td>
          <td>{{calculationResult.reduced_tax_rate.tax | currency }}</td>
        </tr>
        <tr class="normal-tax-rate">
          <td>10%対象</td>
          <td>{{calculationResult.normal_tax_rate.sub_total | currency }}</td>
          <td>消費税</td>
          <td>{{calculationResult.normal_tax_rate.tax | currency }}</td>
        </tr>
      </table>
    </div>

    <div class="information">
      <div class="mb-3" v-if="order.order_type === 'catering'">
        <h3>ケータリング配達予定</h3>
        <p>
          配達予定日: {{order.catering_on | moment("YYYY年MM月DD日") || '配達日が決定していません。'}}<br>
          会場入り予定時間: {{order.catering_avalilable_time || '時間が決定していません。'}}<br>
          &#x203B; 搬入・準備に60分いただいております。
        </p>
      </div>

      <template v-else-if="order.order_type === 'delivery'">
        <div class="mb-3">
          <h3>デリバリー配達予定</h3>
          <p>
            配達予定日: {{order.delivery_on | moment("YYYY年MM月DD日") || '配達日が決定していません。'}}<br>
            配達予定時間: {{order.delivery_time_range || '配達時間が決定していません。'}}<br>
            &#x203B; 道路状況により60分枠をとらさせていただいております。
          </p>
        </div>

        <div class="mb-3">
          <h3>消費税について</h3>
          <p>&#x203B; ドリンク(アルコール)は消費税が10%のためお食事等の小計と消費税の表示を分けさせていただいております。</p>
        </div>
      </template>

      <div class="mb-3">
        <h3>キャンセル規定</h3>
        <ul>
          <li>・ご予約後、配達日の3日前50%、2日前80%、前日・当日100%のキャンセル料金が発生いたします。</li>
          <li>・5万円を超えるご注文の場合は、7日前〜4日前まで30%のキャンセル料金が発生いたします。</li>
          <li>・お申込後の人数減少の場合でも減少人数様に対して上記の%のキャンセル料が発生いたします。</li>
        </ul>
      </div>

      <div v-if="order.use_tablecloth">
        <h3>テーブルクロスについて</h3>
        <p>
          こちらが用意した料理とドリンクをご提供するテーブルのみにおつけします。<br>
          準備時間が短い場合やテーブルの形状によっては、テーブルクロスをおつけできない場合がございます。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
  import { orderTypeJa, mealTypeJa }  from '../../utilities/locale';
  export default {
    props: {
      order: Object,
      calculationResult: Object,
      downloadEstimate: Function
    },
    data: function() {
      return {
        orderTypeJa,
        mealTypeJa
      }
    },
    methods: {
      print() {
        this.$emit('downloadEstimate')
      }
    },
    computed: {
      singleDrinks() {
        return this.order.drinks.filter(option => option.kind !== 'other');
      },
      equipments() {
        return this.order.drinks.filter(option => option.kind === 'other');
      },
    },
    beforeCreate: function () {
      if(window.innerWidth <= 736){
        document.querySelector("meta[name='viewport']").setAttribute("content", "width=736");
      }
    },
    destroyed: function () {
      document.querySelector("meta[name='viewport']").setAttribute("content", "width=device-width,initial-scale=1");
    }
  }
</script>
